/**
 * Created by: cparaschiv
 * Date: 17.05.2013, 17:16
 */

(function(){
    'use strict';

    var CREATE = "create",
        READ = "read",
        UPDATE = "update",
        DESTROY = "destroy",
        identity = function(o) { return o;},
        crud = [CREATE, READ, UPDATE, DESTROY];

    //TS.LazyTransport = kendo.data.RemoteTransport.extend({
    // CP 20140509 - don't inherit RemoteTransport since it cannot be easily extended to raise events
    // derive from TS.Observable instead (most of the methods were overwritten anyway)
    TS.LazyTransport = new Class({

        Extends: TS.Observable,
        type: 'lazy',

        options: {
            parameterMap: identity
        },

        initialize: function(options){
            var me = this;

            me.parent();
            me.init(options);
        },

        // copy/paste from RemoteTransport
        init: function(options) {
            var me = this;

            options = me.options = $.extend({}, me.options, options);
            options.cache = true;
            options.filters && (me.filters = options.filters.slice(0));
            $.each(crud, function(index, type) {
                if (typeof options[type] === 'string') {
                    options[type] = {
                        url: options[type]
                    };
                }
            });

            me.cache = options.cache? kendo.data.Cache.create(options.cache) : {
                find: $.noop,
                add: $.noop
            };

            me.cache.get = function(){
                return this._store;
            };
            me.cache.set = function(store){
                this._store = store;
            };

            if (options.initData) {
                me.data = [options.initData];
            }
        },

        _getFilterValues: function(){
            var me = this,
                ret = {};

            if (!me.filters)
                return ret;

            $.each(me.filters, function(idx, f){
                ret[f.field] = f.value;
            });

            return ret;
        },

        updateFilters: function(filters) {
            var me = this,
                ret = {};

            if (!me.filters)
                return ret;

            $.each(filters, function(idx, f){
                ret[f.field] = f.value;
            });

            return ret;
        },

        create: function(options) {
            options.success(options.data);
        },

        //TODO: timeout
        read: function(options) {
            var me = this,
                success, error,
                result,
                cache = me.cache,
                params,
                i,
                filters = me.filters || me.options.filters || [],
                filterConfig = {};

            options = me.setup(options, READ);
            success = options.success || $.noop;
            error = options.error || $.noop;

            params = { name: me.options.dataSourceName, modelUID: me.options.modelUID };
            me.options.subdomain && (params.subdomain = me.options.subdomain);

            $.each(filters, function(idx, flt){
                filterConfig['name'] = flt['value'];
                // CM 20131104 - use proper JSONification
                if (flt.value && typeof flt.value === 'object' &&
                    typeof flt.value.toJSON === 'function') {
                    flt.value = flt.value.toJSON(null);
                }
            });

            params.filters = filters;
            if(me.options.sendKeyword && TS.isDefined(options.data.filter))
            {       
                var searchfilter = options.data.filter.filters[0];
                if (searchfilter) {
                    searchfilter.field = me.options.keywordField || "Keyword";
                    if (searchfilter.value == "")
                        searchfilter.value = "@";
                    var nonSearchFilters = params.filters.filter(function (obj) {
                        return obj.field != searchfilter.field;
                    });
                    nonSearchFilters.push(searchfilter);
                    params.filters = nonSearchFilters;
                }
            }
            else
                if (TS.isEmpty(filters) && TS.isDefined(options.data.filter)) {
                    params.filters = options.data.filter.filters;
                }

            options.data = params;

            result = cache.find(options.data);

            if(result !== undefined) {
                success(result);
            } else {

                options.success = function(resp, textStatus, jqXHR) {
                    var notif,
                        newArr;

                    if (resp.sessionExpired === true) {
                        TS.UI.showSessionExpired(resp.redirectUrl);
                        return;
                    }

                    //CP 20140108 - response might not contain records, but error messages
                    if (resp.hasOwnProperty('success') && resp.success === false){
                        notif = TS.Util.getNotifications(resp);
                        if (notif.errors){
                            if (typeof error === 'function'){
                                error(resp);
                            } else {
                                TS.Notify.error(notif.errors);
                            }
                        }
                    } else {
                        TS.makeDates(resp.records);
                        if (me.options.allowEmptySelection){
                            newArr = me.insertUnspecifiedRecord(resp.records);
                        } else {
                            newArr = resp.records;
                        }

                        cache.add(options.data, newArr);

                        success(newArr);
                        me.fireEvent('loaded', { items: newArr });
                    }
                };

                $.ajax(options);
            }
        },

        insertUnspecifiedRecord: function(records) {
            var me = this,
                unspecifiedObj = {},
                ret = [];

            unspecifiedObj[me.options.valueProperty] = null;
            unspecifiedObj[me.options.textProperty] = me.options.emptyText || TS.cultures.current.common.EmptySelection;
            ret.push(unspecifiedObj);
            Array.prototype.push.apply(ret, records);

            return ret;
        },

        update: function(options) {
            options.success(options.data);
        },

        destroy: function(options) {
            options.success(options.data);
        },

        // copy/paste from kendo's RemoteTransport
        setup: function(options, type) {
            options = options || {};

            var me = this,
                operation = me.options[type];

            options = $.extend(true, {}, operation, options);
            return options;
        },

        invalidateCache: function(){
            var me = this;
            me.cache.clear();
            me.options.cacheCleared = true;
        },

        copyCache: function(other){
            var me = this;

            me.cache.set(other.cache.get());
        }
    });

    $.extend(true, kendo.data.transports, {
        "lazy": TS.LazyTransport
    });

})();
